import { Table, Tag, Spin, PageHeader, Select, Tabs } from "antd";

import { relativeTimeThreshold } from "moment";
import React, { Component } from "react";

import Dialog from "../shared/dialog";
import "../shared/css/list-page.css";
import "../shared/css/headerpages.css";
import "../shared/css/table.css";

const data = [
  {
    key: 1,
    title: "คุณภาพชีวิตในการทำงานและความผูกพันต่อองค์กร",
    name1: "น้อยมาก",
    name2: "น้อย",
    name3: "ปานกลาง",
    name4: "มาก",
    name5: "มากที่สุด",
  },
  {
    key: 2,
    title: "ความสุขในการทำงาน",
    name1: "น้อยมาก",
    name2: "น้อย",
    name3: "ปานกลาง",
    name4: "มาก",
    name5: "มากที่สุด",
  },
];

const columns = [
  {
    title: "แบบประเมิน",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "แปลความหมายของระดับค่าเฉลี่ย",
    children: [
      {
        title: "1.00-1.49",
        dataIndex: "name1",
        key: "name1",
      },
      {
        title: "1.50-2.49",
        dataIndex: "name2",
        key: "name2",
      },
      {
        title: "2.50-3.49",
        dataIndex: "name3",
        key: "name3",
      },
      {
        title: "3.50-4.49",
        dataIndex: "name4",
        key: "name4",
      },
      {
        title: "4.50-5.00",
        dataIndex: "name5",
        key: "name5",
      },
    ],
    dataIndex: "avg",
    key: "avg",
  },
];

export default class WorkLifeReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: this.props.lang,
      Datasource: [],
      DataSourceColumnTH: [],
      DataSourceColumnEN: [],
      Columns: [],
      query: "",
      queryPrim: "",
      results: [],
      resultsPrim: [],
      selectedRowKeys: [],
      selectedRowKeysPrim: [],

      searchBy: "EmpId",
      searchByPrim: "EmpId",
      DatasourcePrimary: [],
    };
    this.dialog = new Dialog();
  }

  componentDidMount() {
    console.log("statequery", this.state.query);
    fetch(process.env.REACT_APP_API_URL + "/api/getEmpDataForBackState", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: "f18ddd26-f184-4bce-9368-0c613e055bc0",
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("result", result);
      });
  }

  renderTable() {
    return (
      <div>
        <table id="table-example-1">
            {/* render table header */}
          <tr>
            <th rowspan="2"> </th>
            <th rowspan="2">เกณฑ์ประเมิน</th>
            <th rowspan="2">ร้อยละของผู้ประเมินต่อผู้มีสิทธิประเมิน</th>
            <th rowspan="2"> ร้อยละ </th>
            <th colspan="5"> ค่าเฉลี่ย </th>
            <th rowspan="2"> ความหมาย </th>
          </tr>
          <tr>
            <th>5</th>
            <th>4</th>
            <th>3</th>
            <th>2</th>
            <th>1</th>
          </tr>
{/* end render table header */}

{/* render bo table */}

            <tr>
                <td> 1 </td>
                <td> ด้านค่าตอบแทนที่เพียงพอและยุติธรรม </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
            </tr>

            <tr>
                <td> 2 </td>
                <td> ด้านสภาพแวดล้อมการทำงานที่ปลอดภัยและการส่งเสริมสุขภาพ </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
            </tr>

            <tr>
                <td> 3 </td>
                <td> ด้านความก้าวหน้าและความมั่นคงในงาน </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
            </tr>

            <tr>
                <td colspan="2"> รวมด้านความสุขในการทำงาน </td>
              
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
                <td> </td>
            </tr>
          
        </table>
      </div>
    );
  }

  render() {
    return (
      <div style={{ textAlign: "center", marginLeft: 15, marginRight: 15 }}>
        <h3>
          รายละเอียดผลการประเมินคุณภาพชีวิตในการทำงานและความผูกพันต่อองค์กร
          และความสุขในการทำงาน ประจำปีการศึกษา 2564
        </h3>

        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          bordered
        />

        <p>
          {" "}
          <b> ตาราง </b>{" "}
          ค่าเฉลี่ยระดับคุณภาพชีวิตในการทำงานและความผูกพันต่อองค์กร
          และความสุขในการทำงานประจำปีการศึกษา 2564
        </p>

        {this.renderTable()}
      </div>
    );
  }
}
